import React, {useState} from 'react';
import {FormLayout, Modal, Select, SkeletonBodyText, TextField, TextStyle} from '@shopify/polaris';
import {apiFetch} from './useFetchApi';

/**
 *
 */
export default function useAskAi({appOptions}) {
  const [showAskAi, setShowAskAi] = useState(false);
  const [askAiContent, setAskAiContent] = useState('');
  const [askAiAnswer, setAskAiAnswer] = useState('');
  const [appToAsk, setAppToAsk] = useState('joyio');
  const [loadingAiResp, setLoadingAiResp] = useState(false);
  const [fromTime, setFromTime] = useState(new Date().setDate(new Date().getDate() - 30));
  const [toTime, setToTime] = useState(new Date());

  const handleAskAi = async () => {
    try {
      setLoadingAiResp(true);
      const resp = await apiFetch(`${process.env.REACT_APP_API_URL}/api/askAi/reviews`, {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({
          appId: appToAsk,
          message: askAiContent,
          fromTime,
          toTime
        })
      });
      const {data: respData} = await resp.json();
      setAskAiAnswer(respData.response);
    } catch (e) {
      console.error(e);
    } finally {
      setLoadingAiResp(false);
    }
  };

  const modal = (
    <Modal
      open={showAskAi}
      onClose={() => setShowAskAi(false)}
      title="Ask AI"
      primaryAction={{
        content: 'Ask',
        onAction: handleAskAi,
        disabled: askAiContent.length === 0,
        loading: loadingAiResp
      }}
      secondaryActions={[
        {
          content: 'Close',
          onAction: () => {}
        }
      ]}
    >
      <Modal.Section>
        <FormLayout>
          <FormLayout.Group>
            <TextField
              label="From Time"
              type="date"
              value={new Date(fromTime).toISOString().split('T')[0]}
              onChange={val => setFromTime(new Date(val))}
            />
            <TextField
              label="To Time"
              type="date"
              value={new Date(toTime).toISOString().split('T')[0]}
              onChange={val => setToTime(new Date(val))}
            />
          </FormLayout.Group>

          <Select
            value={appToAsk}
            onChange={val => setAppToAsk(val)}
            options={appOptions.map(app => ({
              label: app.name,
              value: app.appId
            }))}
            label={'App to ask'}
          />
          <TextField
            label={''}
            labelHidden={true}
            value={askAiContent}
            onChange={val => setAskAiContent(val)}
            multiline={5}
            placeholder={'How is the customer support insights via reviews so far?'}
            helpText={'Best for extracting information from reviews content for insights...'}
          />
          {loadingAiResp && <SkeletonBodyText lines={5} />}
          {!loadingAiResp && askAiAnswer && (
            <TextStyle>
              <pre style={{whiteSpace: 'pre-wrap', margin: 0}}>{askAiAnswer}</pre>
            </TextStyle>
          )}
        </FormLayout>
      </Modal.Section>
    </Modal>
  );

  return {modal, openModal: () => setShowAskAi(true), closeModal: () => setShowAskAi(false)};
}
